<div class="step-container">
    <img src="svg/email-envelope.svg" alt="Email" class="email-icon">
    <div class="step-header">Check your email</div>
    <div class="step-subheader">Thanks for signing up to InsightHub, {{ firstName }}.<br>We're happy to have you.</div>
    <div class="step-content">
        <div class="confirmation-text">
            We've sent a confirmation email to {{ email }}. Click the link in the email to complete your sign-up and log in.
        </div>
        <div class="resend-text">
            Didn't receive the email?<br>Check your spam folder or <span class="resend-link" (click)="onResendEmail()" [class.resending]="isResending">{{ isResending ? 'sending...' : 'resend email' }}</span>.
        </div>
    </div>
</div>
